import { useState } from 'react';
import { useGetEnquiriesQuery } from './enquiries.api';

import { useNavigate } from 'react-router-dom';
import { Pager } from '../pager/pager';
import { FilterBar } from '../filter-bar/filter-bar';
// import { EnquiryStatus } from './equiries.types';
import { DateTime } from '../datetime/datetime';
import { EnquiryStatus } from '@topshots/core-models';
import { Card, CardContent } from 'shared-components';
import { PageTitle } from 'shared-components';
import Routes from '../../app/routes';

export const Enquiries = () => {
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [status, setStatus] = useState<EnquiryStatus | ''>('');
  const [search, setSearch] = useState<string | undefined>(undefined);
  const { data, isLoading } = useGetEnquiriesQuery({
    page,
    perPage,
    status,
    search,
  });
  const navigate = useNavigate();

  if (isLoading) {
    return <span>loading...</span>;
  }
  return (
    <>
      <PageTitle
        title="Enquiries"
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.ENQUIRIES.title, link: Routes.ENQUIRIES.link },
        ]}
      />

      <Card>
        <CardContent>
          <FilterBar
            value={{
              status: status as string,
            }}
            filters={[
              {
                key: 'status',
                title: 'Status',
                options: [
                  { display: 'Open', value: EnquiryStatus.Open },
                  { display: 'Closed', value: EnquiryStatus.Closed },
                  { display: 'All', value: '' },
                ],
                //default: status,
              },
            ]}
            onFilterChanged={(filter, values) => {
              //setStatus(values['status']);
              switch (filter.key) {
                case 'status':
                  setStatus(values as EnquiryStatus);
                  break;
              }
            }}
            onSearch={(term) => {
              setSearch(term === '' ? undefined : term);
            }}
          />
        </CardContent>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Message</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data?.data.map((e) => (
              <tr
                onClick={() => {
                  navigate(`${e._id}`);
                }}
                key={e._id.toString()}
              >
                <td>
                  <DateTime d={e.created_on} />
                </td>
                <td>{e.name}</td>
                <td>{e.message}</td>
                <td>{e.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pager
          onNext={() => {
            setPage(page + 1);
          }}
          onPrevious={() => {
            setPage(page - 1);
          }}
          onPageSelected={(selected) => {
            setPage(selected);
          }}
          onPerPageChange={(selected) => {
            setPerPage(selected);
            setPage(1);
          }}
          page={page}
          perPage={perPage}
          totalPages={data?.totalPages ?? 1}
        />
      </Card>
    </>
  );
};
